// extracted by mini-css-extract-plugin
export default {"listWrapper":"List_listWrapper__uUAyy"};